import { BillingMultipliers } from '@/types/BillingMultipliers'
import { RootState } from '.'
import { Module } from 'vuex'
import firebase from 'firebase'

export interface BillingMultipliersState {
  billingMultipliers: BillingMultipliers | null
  unsubscribeFromBillingMultipliers: () => void
}

const BillingMultipliersDocId = 'billingMultipliers'

const billingMultipliersModule: Module<BillingMultipliersState, RootState> = {
  namespaced: true,

  state: {
    billingMultipliers: null,
    unsubscribeFromBillingMultipliers: () => void {},
  },

  getters: {
    billingMultipliers: (state) => state.billingMultipliers,
  },

  mutations: {
    setBillingMultipliers(state, data: BillingMultipliers | null) {
      state.billingMultipliers = data
    },
    setUnsubscribeFromBillingMultipliers(state, data: () => void) {
      state.unsubscribeFromBillingMultipliers = data
    },
  },

  actions: {
    subscribeToBillingMultipliers: async ({ commit, dispatch }) => {
      try {
        commit('setLoading', true, { root: true })
        dispatch('unsubscribeFromBillingMultipliers')

        const billingMultipliersDoc = firebase
          .firestore()
          .collection('settings')
          .doc(BillingMultipliersDocId)

        const unsubsFunc = billingMultipliersDoc.onSnapshot(
          (snapshot) => {
            if (snapshot.exists) commit('setBillingMultipliers', snapshot.data())
            else commit('setBillingMultipliers', null)
          },
          (error) => {
            commit('setError', error.message, { root: true })
          }
        )

        commit('setUnsubscribeFromBillingMultipliers', unsubsFunc)
      } catch (error: any) {
        commit('setError', error.message, { root: true })
      } finally {
        commit('setLoading', false, { root: true })
      }
    },

    unsubscribeFromBillingMultipliers: ({ state, commit }) => {
      state.unsubscribeFromBillingMultipliers()
      commit('setUnsubscribeFromBillingMultipliers', () => void {})
    },

    createBillingMultipliers: async (
      { commit },
      newBillingMultipliers: BillingMultipliers
    ): Promise<string | undefined> => {
      try {
        commit('setLoading', true, { root: true })

        const settingsCollection = firebase.firestore().collection('settings')
        await settingsCollection.doc(BillingMultipliersDocId).set(newBillingMultipliers)

        commit('setSuccess', 'Billing multiplier successfully created!', { root: true })

        return BillingMultipliersDocId
      } catch (error: any) {
        commit('setError', error.message, { root: true })
      } finally {
        commit('setLoading', false, { root: true })
      }
    },

    updateBillingException: async (
      { commit },
      newBillingMultipliers: BillingMultipliers
    ): Promise<void> => {
      try {
        commit('setLoading', true, { root: true })

        const settingsCollection = firebase.firestore().collection('settings')
        await settingsCollection.doc(BillingMultipliersDocId).set(newBillingMultipliers)

        commit('setSuccess', 'Billing multiplier successfully modified!', { root: true })
      } catch (error: any) {
        commit('setError', error.message, { root: true })
      } finally {
        commit('setLoading', false, { root: true })
      }
    },
  },
}

export default billingMultipliersModule
